import type { IRecord } from '@gp/types/global';

export const CHANGE_DETAIL_TAB_CONFIG = {
  key: 'ChangeDetail',
  title: 'Change Detail',
};

export const CHANGE_CHECKLIST_TAB_CONFIG = {
  key: 'ChangeChecklist',
  title: 'Change Checklist',
};

export const CHANGE_LOG_DEFAULT_ACTIVE_ID = CHANGE_DETAIL_TAB_CONFIG.key;

export const TAB_NAME_KEY_MAPPING = {
  OVERVIEW: 'overview',
  DETAIL: 'detail',
  OVERVIEW: 'overview',
  MILESTONE: 'milestone',
  UPDATE: 'update',
  FINANCE: 'finance',
  STAKEHOLDER: 'stakeholder',
  TECHNICAL: 'tech',
};

export const TAB_NAME_MAPPING: IRecord<string> = {
  [TAB_NAME_KEY_MAPPING.DETAIL]: 'Detail',
  [TAB_NAME_KEY_MAPPING.OVERVIEW]: 'Overview',
  [TAB_NAME_KEY_MAPPING.MILESTONE]: 'Milestone',
  [TAB_NAME_KEY_MAPPING.UPDATE]: 'Update',
  [TAB_NAME_KEY_MAPPING.FINANCE]: 'Finance',
  [TAB_NAME_KEY_MAPPING.STAKEHOLDER]: 'Stakeholder',
  [TAB_NAME_KEY_MAPPING.TECHNICAL]: 'Tech',
};

export const TAB_NAME_KEY_LIST: string[] = [
  TAB_NAME_KEY_MAPPING.DETAIL,
  TAB_NAME_KEY_MAPPING.OVERVIEW,
  TAB_NAME_KEY_MAPPING.MILESTONE,
  TAB_NAME_KEY_MAPPING.UPDATE,
  TAB_NAME_KEY_MAPPING.FINANCE,
  TAB_NAME_KEY_MAPPING.STAKEHOLDER,
  TAB_NAME_KEY_MAPPING.TECHNICAL,
];
